import 'react-loading-skeleton/dist/skeleton.css';

import React, {
  useEffect,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import {
  cloneDeep,
  isEmpty,
} from 'lodash';
import { Line } from 'rc-progress';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { isAdmin } from 'state';
import styled from 'styled-components';

import profile from '../../../../../assets/images/banner.png';
import PenImg from '../../../../../assets/images/pen.png';
import { dateUtil } from '../../../../../util';
import {DropdownMenu, Pagenation} from "../../../../components";
import SearchIcon from "../../../../../assets/images/icon/SearchIcon";
import EmptyBox from "../../../../components/common/EmptyBox";
import {fadeIn, fadeIn3, fadeInS} from "../../../../../styled/StyledComponent";
import Zoom from "../../../../../assets/images/icon/Zoom";
import EyeOpen from "../../../../../assets/images/icon/EyeOpen";
import EditIcon from "../../../../../assets/images/icon/EditIcon";
import {AiOutlineClose} from "react-icons/ai";
import {MdClose} from "react-icons/md";
import ListButtonItem from "../../../../components/common/ListButtonItem";
import axios from "axios";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

const categoryArr = [
    {
        dropdownItem:"All",
        display:"All",
        params:""
    },
    {
        dropdownItem:"Draft",
        display:"Draft",
        params:"DRAFT"
    },
    {
        dropdownItem:"Submitted",
        display:"Submitted",
        params:"IN_PROGRESS"
    },
    {
        dropdownItem:"Published",
        display:"Published",
        params:"PUBLISHED"
    },
]
export const returnColor = (text) => {
    switch (text) {
        case "DRAFT":{
            return "#FFC8DD"
        }
        case "IN_PROGRESS":{
            return "#9AE3B7"
        }
        case "PUBLISHED":{
            return "#B0CBFF"
        }
        default:
            break;
    }
};


const skeArr = [0, 0, 0, 0, 0];

function Post({ loading = true }) {
    return (
        <div className="post">
            <div className="left-col">
                <div className="avatar" style={{ borderRadius: 6 }}>
                    {loading && <Skeleton height="100%" containerClassName="avatar-skeleton" />}
                    <img
                        src="smile.svg"
                        alt="A user avatar"
                        style={{ display: loading ? "none" : undefined }}
                    />
                </div>
            </div>
            <div className="right-col">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Skeleton count={1} style={{ height: 30, width: "120px" }} />
                    <Skeleton count={1} style={{ height: 30, width: "120px" }} />
                </div>

                <Skeleton count={1} style={{ height: 30, width: "55%" }} />
                <Skeleton count={1} style={{ height: 40 }} />
            </div>
        </div>
    );
}

const SubClasses = () => {
    const navigate = useNavigate();
    const adminCheck = useRecoilValue(isAdmin);
    const [searchText, setSearchText] = useState("");
    const [list, setList] = useState([]);
    const [renderPost, setRenderPost] = useState(true);
    const [loading, setLoading] = useState(false)
    const [categoryParams, setCategoryParams] = useState(    {
        dropdownItem:"All",
        display:"All",
        params:""
    },);
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    const [focus, setFocus] = useState(false)
    const getClassItem = async () => {
        setLoading(true)
        // axios.get("")
        try {
            await classesAPI
                .getClassList({
                    params:{
                        progress:categoryParams?.params,
                    },
                    data:{
                        pageable:{
                            size: 5,
                            page: pageInfo?.number,
                        },
                    }
                })
                .then((res) => {
                    setList(cloneDeep(res?.data?.content));
                    console.log("@res",res);
                    setPageInfo({
                        ...pageInfo,
                        totalPages:res?.data?.totalPages,
                        // number:res?.number,
                        // size:res?.size
                    })
                    setLoading(false)
                });

        }catch (e){
            setLoading(false)
            console.log("@e",e);
        }

    };

    const gotoCreateStep = (id: any) => {
        navigate("/create/details", {
            state: {
                createId: id,
            },
        });
    };

    const returnStatus = (progress) => {
        switch (progress) {
            case "IN_PROGRESS": {
                return "SUBMITTED";
            }

            default: {
                return progress;
            }
        }
    };

    useEffect(() => {
        getClassItem();
    }, [categoryParams?.params, pageInfo.number]);

    useEffect(() => {
        setTimeout(() => {
            setRenderPost(false);
        }, 400);
    }, []);

    return (
        <Container>
            <ContentsInner>
                <SearchArea style={{ marginBottom: 15 }}>
                    <DropDownArea>
                        <DropDownWrap>
                            <DropdownMenu
                                selected={categoryParams?.display}
                                altText="Select Category"
                                borderColor={"#E5E5E5"}
                                height={40}
                                onClick={(...rest)=>{
                                    setCategoryParams(rest[3])
                                }}
                                items={categoryArr}
                            />
                        </DropDownWrap>
                        {/*<DropDownWrap*/}
                        {/*    className={"newest"}*/}
                        {/*>*/}
                        {/*    <DropdownMenu*/}
                        {/*        selected={""}*/}
                        {/*        altText="Newest"*/}
                        {/*        borderColor={"#E5E5E5"}*/}
                        {/*        height={40}*/}
                        {/*        items={[]}*/}
                        {/*    />*/}
                        {/*</DropDownWrap>*/}
                    </DropDownArea>
                    <InputArea
                        className={focus ? "on" : ""}
                    >
                        <input
                            onFocus={() => {
                                setFocus(true)
                            }}
                            onBlur={() => {
                                setFocus(false)
                            }}
                            value={searchText}
                            onChange={(e)=>{
                                setSearchText(e.target.value);
                            }}
                            type="text" placeholder="Search.."/>
                        {
                            searchText !== "" &&
                            <div
                                onClick={() => {
                                    setSearchText("")
                                }}
                                className="close">
                                <MdClose/>
                            </div>
                        }
                        <div className={"searchBtn"}>
                            <SearchIcon/>
                            <span>Search</span>
                        </div>
                    </InputArea>
                </SearchArea>
                <MainHeader></MainHeader>
                <Wrap>
                    {/*{renderPost === true &&*/}
                    {/*    skeArr.map((item) => (*/}
                    {/*        <PostWrap>*/}
                    {/*            <div className="mb-4">*/}
                    {/*                <Post loading={true} />*/}
                    {/*            </div>*/}
                    {/*        </PostWrap>*/}
                    {/*    ))}*/}

                    {!isEmpty(list) &&
                        renderPost === false &&
                        list?.map((item: any, index) => {
                            return (
                                <ListItem
                                    index={0.3}
                                >
                                    <Thumb className={"thumb"}>
                                        <img src={item?.thumbnailUrl || profile} alt="" />
                                    </Thumb>
                                    <ListContents>
                                        <ListMain>
                                            <Category style={{background:(returnColor(item?.progress || ""))}}>
                                            <span>
                                                {(
                                                    (adminCheck
                                                            ? item?.progress
                                                            : returnStatus(item?.progress || "")
                                                    )
                                                        ?.charAt(0)
                                                        ?.toUpperCase() +
                                                    (adminCheck
                                                            ? item?.progress
                                                            : returnStatus(item?.progress || "")
                                                    )
                                                        ?.slice(1)
                                                        ?.toLowerCase()
                                                )?.replace("_", " ")}
                                                {}
                                            </span>
                                            </Category>
                                            <h3>{item?.classTitle}</h3>
                                            <DateItem>
                                            <span>
                                                {dateUtil.mainCardDateFormat(item?.updatedDatetime)}
                                            </span>
                                            </DateItem>
                                            {/*<Progress>*/}
                                            {/*<span>*/}
                                            {/*    <b>78</b>&nbsp;/&nbsp;100*/}
                                            {/*</span>*/}
                                            {/*    <ProgressBar>*/}
                                            {/*        <Line*/}
                                            {/*            percent={70}*/}
                                            {/*            trailWidth={0.7}*/}
                                            {/*            style={{*/}
                                            {/*                border: "solid 1px #e9ecef",*/}
                                            {/*                borderRadius: 4,*/}
                                            {/*            }}*/}
                                            {/*            trailColor={"#fff"}*/}
                                            {/*            strokeWidth={0.7}*/}
                                            {/*            strokeColor="#ddc160"*/}
                                            {/*        />*/}
                                            {/*    </ProgressBar>*/}
                                            {/*</Progress>*/}

                                        </ListMain>
                                        {/*<ListButton*/}
                                        {/*    onClick={() => {*/}
                                        {/*        gotoCreateStep(item?.id);*/}
                                        {/*    }}*/}
                                        {/*>*/}
                                        {/*    <span>{item?.progress === "DRAFT" ? "Edit" : "View"}</span>*/}
                                        {/*    /!*<img src={PenImg} alt="" />*!/*/}

                                        {/*</ListButton>*/}
                                        <ListButtonItem
                                            onClick={()=>{
                                                gotoCreateStep(item?.id);
                                            }}
                                            text={item?.progress === "DRAFT" ? "Edit" : "View"}
                                        >
                                            {item?.progress !== "DRAFT" ? (
                                                <Zoom />
                                            ) : (
                                                // <img src={"/images/pen.png"} alt="" />
                                                <EditIcon/>
                                            )}
                                        </ListButtonItem>
                                    </ListContents>

                                </ListItem>
                            );
                        })}
                        {
                            isEmpty(list) && loading == false &&
                            <EmptyBox url={"/images/nothing.png"} />
                        }

                </Wrap>

            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default SubClasses;

const Container = styled.div`
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    height: 100%;
`;
const MainHeader = styled.div``;
const ContentsInner = styled.div`
    padding: 20px;
    //overflow: hidden;
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        & > div{
            width: 100%;
        }
    }
`;
const DropDownArea = styled.div`
    display: flex;
    width: 50%;
`;
const InputArea = styled.div`
    width: 37%;
    display: flex;
    height: 40px!important;
    border-radius: 8px;
    overflow: hidden;
    align-items: center;
    flex-direction: row;
    border: solid 2px rgba(51, 51, 51, 0);
    box-sizing: content-box;
    transition: all 0.2s;
    position: relative;
    cursor: default;

    .close{
            cursor: pointer;
            position: absolute;
            height: 90%;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            right: 89px;
            background: #fff!important;
            border-radius: 50%;
            
            svg{
                width: 18px;
                height: 18px;
                path{
                   &:nth-last-of-type(1){
                       stroke-width: 1px;
                   }
                }
            }
    }
    &.on {
        border: solid 2px #333;
    }
    
    input {
        &:focus {
            border: none!important;
        }
    }

    div {
        &:hover {
            background: #d5d5d5;
        }
        transition: all 0.2s;
        height: 100%;
        box-sizing: border-box;
        padding: 0 8px;
        background: #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            padding-bottom: 0px;
        }

        span {
            font-weight: 700;
            font-size: 16px;
            margin-left: 8px;
        }
    }

    input {
        padding-left: 15px;
        outline: none;
        display: flex;
        height: 100%;
        width: 100%;
        flex: 1;
        border-radius: 8px 0 0 8px;
        border: solid 1px #e5e5e5;
        border-right: none;

        &::placeholder {
            opacity: 0.5;
        }
    }
`;

const DropDownWrap = styled.div`
    width: 60%;
    margin-right: 15px;
    @media screen and (max-width: 768px) {
        width: 100%;
        margin-bottom: 16px;
        margin-right: 0;
        &.newest{
            margin-right: 0!important;
        }    
    }
    
`;
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    min-height: 400px;
    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const ListItem = styled.div<{index?:any}>`
    display: flex;
    animation: ${fadeIn3} ${props => props.index}s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    position: relative;
    padding: 20px 0;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
    //@media screen and (max-width: 768px) {
    //    flex-direction: column;
    //    .thumb{
    //        height: auto;
    //        width: 100%;
    //        aspect-ratio: 2 / 1;
    //        margin-bottom: 1rem;
    //    }
    //}
`;
const ListContents = styled.div`
   display: flex;
    width: 100%;
    justify-content: space-between;
`
const Thumb = styled.div`
    background: #ddd;
    overflow: hidden;
    width: 109px;
    height: 109px;
    min-width: 109px;
    border-radius: 5px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
const ListMain = styled.div`
    padding: 0 20px;
    flex: 1;
    //@media screen and (max-width: 768px) {
    //    padding: 0;
    //    h3{
    //       padding-top: 15px;
    //    }
    //}
    h3 {
        word-break: break-word;
        color: #333;
        font-size: 26px;
        margin: 8px 0 9.6px 0;
    }
`;
const Category = styled.div`
    padding: 7px 12px 7px 12px;
    line-height: 1;
    background: #f0a8a8;
    width: 85px;
    font-size: 12px;
    color: #333;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 4px;
    span {
        text-transform: capitalize;
    }
`;
const DateItem = styled.div`
    span {
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        opacity: 0.5;
        font-family: "Source Serif 4", sans-serif;
    }
`;
const Progress = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    color: rgba(51, 51, 51, 0.6);
    text-align: end;
    margin-bottom: 0.25rem;
    max-width: 500px;
    b {
        color: #333;
    }
`;
const ProgressBar = styled.div``;
const ListButton = styled.div`
    background: #333;
    width: 80px;
    height: 30px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: solid 1px #333;
    //&:hover{
    //    background: #fff;
    //    span{
    //        color: #333!important;   
    //    }
    //}
    transition: all 0.2s;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            display: block;
            path{
                fill: #333;
            }
        }
    }
    svg{
        display: block;
        path{
            fill: #fff;
        }
    }
    @media screen and (max-width: 768px) {
        position: absolute;
        right: 0px;
    }
    span {
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;
const PostWrap = styled.div`
    position: relative;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid rgba(51, 51, 51, 0.2);

    .post {
        display: flex;
    }

    .post .left-col {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 1.5rem;
    }

    .post .avatar {
        width: 113px;
        height: 113px;
        background-color: #eaeaea;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .post .avatar-skeleton {
        width: 100%;
        height: 100%;
        line-height: 1;
    }

    .post .avatar img {
        width: 70%;
        height: 70%;
    }

    .post .right-col {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .post h3 {
        font-size: 1.3rem;
    }

    .list-item {
        width: 200px;
        padding: 0.5rem;
        border: 1px solid #ccc;
    }

    .list-item:not(:last-child) {
        border-bottom: none;
    }
`;
